/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  GenericVRFCenterLogic,
  GenericVRFCenterLogicInterface,
} from "../../../../contracts/dependant/vrfCenter/GenericVRFCenterLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "randomness",
        type: "bytes32",
      },
    ],
    name: "FeedVRF",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
    ],
    name: "RequestVRF",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "randomness",
        type: "bytes32",
      },
    ],
    name: "StuffVRF",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "randomness",
        type: "bytes32",
      },
    ],
    name: "VerifyVRF",
    type: "event",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "requestId",
            type: "bytes32",
          },
          {
            internalType: "uint256[2]",
            name: "publicKey",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "proof",
            type: "uint256[4]",
          },
          {
            internalType: "uint256[2]",
            name: "uPoint",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "vComponents",
            type: "uint256[4]",
          },
        ],
        internalType: "struct GenericVRFCenterType.VerifyParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "feedVrf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "requestId",
            type: "bytes32",
          },
          {
            internalType: "uint256[2]",
            name: "publicKey",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "proof",
            type: "uint256[4]",
          },
          {
            internalType: "uint256[2]",
            name: "uPoint",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "vComponents",
            type: "uint256[4]",
          },
        ],
        internalType: "struct GenericVRFCenterType.VerifyParam[]",
        name: "params",
        type: "tuple[]",
      },
    ],
    name: "feedVrfs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[2]",
        name: "publicKey",
        type: "uint256[2]",
      },
    ],
    name: "publicKeyToAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "reason",
        type: "bytes32",
      },
    ],
    name: "requestVrf",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "requestId",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "randomness",
            type: "bytes32",
          },
        ],
        internalType: "struct GenericVRFCenterType.StuffParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "stuffVrf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "requestId",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "randomness",
            type: "bytes32",
          },
        ],
        internalType: "struct GenericVRFCenterType.StuffParam[]",
        name: "params",
        type: "tuple[]",
      },
    ],
    name: "stuffVrfs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "requestId",
            type: "bytes32",
          },
          {
            internalType: "uint256[2]",
            name: "publicKey",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "proof",
            type: "uint256[4]",
          },
          {
            internalType: "uint256[2]",
            name: "uPoint",
            type: "uint256[2]",
          },
          {
            internalType: "uint256[4]",
            name: "vComponents",
            type: "uint256[4]",
          },
        ],
        internalType: "struct GenericVRFCenterType.VerifyParam",
        name: "param",
        type: "tuple",
      },
    ],
    name: "verifyVrf",
    outputs: [
      {
        internalType: "bytes32",
        name: "randomness",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
    ],
    name: "vrfAlphaString",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
    ],
    name: "vrfBetaString",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GenericVRFCenterLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GenericVRFCenterLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GenericVRFCenterLogic__factory extends ContractFactory {
  constructor(...args: GenericVRFCenterLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GenericVRFCenterLogic> {
    return super.deploy(overrides || {}) as Promise<GenericVRFCenterLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GenericVRFCenterLogic {
    return super.attach(address) as GenericVRFCenterLogic;
  }
  override connect(signer: Signer): GenericVRFCenterLogic__factory {
    return super.connect(signer) as GenericVRFCenterLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GenericVRFCenterLogicInterface {
    return new utils.Interface(_abi) as GenericVRFCenterLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericVRFCenterLogic {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as GenericVRFCenterLogic;
  }
}
